module.exports = __webpack_public_path__ + "static/media/3.8fc8ad3e.png";